import { useEffect, useState } from "react";
import { NAV_LINKS } from "@/mocks/content";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <header
      className={
        "fixed top-0 left-0 z-50 w-full transition-all duration-300 " +
        (scrolled
          ? "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
          : "bg-transparent")
      }
    >
      <nav className="mx-auto flex h-16 max-w-[1400px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2 whitespace-nowrap">
          <span
            className={
              "flex h-9 w-9 items-center justify-center rounded-md text-xl font-black transition-colors " +
              (scrolled ? "bg-primary-500 text-background-50" : "bg-primary-500/90 text-background-50")
            }
          >
            <i className="ri-search-eye-line"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={
                "font-heading text-xl font-black tracking-wide " +
                (scrolled ? "text-foreground-950" : "text-foreground-50")
              }
            >
              爆源
            </span>
            <span
              className={
                "text-[10px] font-medium tracking-[0.2em] " +
                (scrolled ? "text-foreground-500" : "text-foreground-300")
              }
            >
              幕后调查 · 揭秘来源
            </span>
          </span>
        </a>

        <ul className="hidden items-center gap-1 lg:flex">
          {NAV_LINKS.map((item) => (
            <li key={item.href}>
              <a
                href={item.href}
                className={
                  "rounded-md px-3 py-2 whitespace-nowrap text-sm font-medium transition-colors " +
                  (scrolled
                    ? "text-foreground-800 hover:bg-secondary-100 hover:text-foreground-950"
                    : "text-foreground-100 hover:bg-white/10 hover:text-white")
                }
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className={
              "hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex " +
              (scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50 text-primary-700 hover:bg-white")
            }
          >
            深挖线索 <i className="ri-arrow-right-line ml-1"></i>
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen(true)}
            className={
              "flex h-10 w-10 items-center justify-center rounded-md border transition-colors lg:hidden " +
              (scrolled
                ? "border-background-200 text-foreground-900 hover:bg-secondary-100"
                : "border-white/30 text-foreground-50 hover:bg-white/10")
            }
          >
            <i className="ri-menu-line text-xl"></i>
          </button>
        </div>
      </nav>

      {/* mobile drawer */}
      {open && (
        <div className="fixed inset-0 z-50 lg:hidden">
          <button
            type="button"
            aria-label="关闭遮罩"
            onClick={() => setOpen(false)}
            className="absolute inset-0 bg-foreground-950/50"
          ></button>
          <div className="absolute top-0 right-0 flex h-full w-[82%] max-w-xs flex-col bg-background-50 shadow-2xl">
            <div className="flex items-center justify-between border-b border-background-200 px-5 py-4">
              <span className="font-heading text-xl font-black text-foreground-950">爆源娱乐</span>
              <button
                type="button"
                aria-label="关闭菜单"
                onClick={() => setOpen(false)}
                className="flex h-9 w-9 items-center justify-center rounded-md text-foreground-800 hover:bg-secondary-100"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <ul className="flex flex-col gap-1 p-4">
              {NAV_LINKS.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setOpen(false)}
                    className="flex items-center justify-between rounded-md px-4 py-3 text-base font-medium text-foreground-900 hover:bg-secondary-100"
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-foreground-400"></i>
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-auto p-4">
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50 hover:bg-primary-600"
              >
                深挖线索 投稿爆料
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}